// extracted by mini-css-extract-plugin
module.exports = {"myButton":"LargeButton_myButton__3_9Dl"};